import utility from "core/Utils";
import LargeModal from "components/elements/LargeModal";
import Select from "components/elements/Select";
import DateInput from "components/elements/DateInput";
import { ReactComponent as EyeIcon } from "../../../images/eye.svg";
import {
  CLIENT_BROADCASTER,
  CONTENT_TYPES,
  LS_CLONE_SUB_KEY,
  SUB_MODIFY_TYPES,
  SUB_MODIFY_TYPES_REVERSE,
} from "core/Constants";
import dataProvider from "core/DataProvider";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Modal from "components/elements/Modal";

const SubscriptionPreview = props => {
  const [isEditing, setIsEditing] = useState(false);
  const [editType, setEditType] = useState({
    value: SUB_MODIFY_TYPES.SHORT_CLOSE,
    label: "Short Close",
  });
  const [editDate, setEditDate] = useState("");
  const [editRemarks, setEditRemarks] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [itemListItems, setItemListItems] = useState([]);
  const [lastDataDate, setLastDataDate] = useState(null);
  const [groupDetail, setGroupDetail] = useState(null);

  const data = props.data;
  const navigate = useNavigate();

  const onClose = (action = null) => {
    if (props.onClose !== undefined) {
      props.onClose(action);
    }
  };

  const createSubscription = async () => {
    setIsLoading(true);
    try {
      let approvingAuths = [];
      if (data.approvingAuthority) {
        approvingAuths = [data.approvingAuthority.value];
      }

      let reqData = {
        client_id: data.client.value,
        content_type: parseInt(data.contentType.value),
        advertisers_id: data.advertiser.value ? [data.advertiser.value] : [],
        period_from: data.periodFrom,
        period_to: data.periodTo,
        approvers: approvingAuths,
        categories: data.category.map(x => x.value),
        brands: data.brand.map(x => x.value),
        captions: data.caption.map(x => x.value),
        edits: data.edit.map(x => parseInt(x.value)),
        channels: data.channels.map(x => x.value),
      };

      await dataProvider.network.post("subscription", reqData);
      toast.success("Subscription Created");
      navigate("/subscriptions/listing");
    } catch (error) {
      console.error(error);
      toast.error("Failed to create subscription");
      if (error.response) {
        alert(error.response.data.error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const cloneSubscription = () => {
    localStorage.setItem(LS_CLONE_SUB_KEY, JSON.stringify(data));
    navigate("/subscriptions/new");
  };

  const saveModification = async () => {
    // validations
    try {
      if (!editDate) {
        throw new Error("Please select To date");
      }
      if (!editRemarks.length || editRemarks.length < 10) {
        throw new Error("Remarks should be at least 10 characters");
      }
    } catch (error) {
      toast.error(error.message);
      return;
    }

    let reqBody = {
      subscription_id: data.id,
      modification_type: parseInt(editType.value),
      old_date: data.periodTo,
      new_date: editDate,
      remarks: editRemarks,
    };

    try {
      await dataProvider.network.post("subscription/modify", reqBody);
      toast.success("Subscription modified successfully");
      onClose("refresh_listing");
    } catch (error) {
      console.error(error);
      toast.error("Failed to modify subscription");
    }
  };

  const loadListItem = async key => {
    let itemList = [];
    try {
      if (key === "category") {
        let cats = await dataProvider.network.post(`masters/brand-category`, {
          advertisers: [data.advertiserList[0].id],
          content_type: parseInt(data.contentType.value),
        });
        cats = cats.map(x => ({
          label: x.brandcategory,
          value: x.brandcategorycode,
        }));
        itemList = cats;
      }

      if (key === "brand") {
        let brands = await dataProvider.network.post(`min-master/brand`, {
          advertisers: [parseInt(data.advertiserList[0].id)],
          categories: data.categoryList.map(x => parseInt(x.id)),
        });
        brands = brands.map(x => ({ label: x.name, value: x.id }));
        itemList = brands;
      }

      if (key === "channel") {
        let channels = await dataProvider.network.get(`min-master/channels`);
        channels = channels.map(x => ({ value: x.id, label: x.name }));
        itemList = channels;
      }

      if (key === "caption") {
        let catParams = data.categoryList.map(x => `bc=${x.id}`);
        let brandParams = data.brandList.map(x => `b=${x.id}`);

        let url = `min-master/descriptor?advertiser=${data.advertiserList[0].id}&content-type=${data.contentType.value}`;
        if (data.categoryList.length > 0) {
          url += "&" + catParams.join("&");
        }
        if (data.brandList.length > 0) {
          url += "&" + brandParams.join("&");
        }

        let descriptors = await dataProvider.network.get(url);
        itemList = descriptors.map(x => ({ label: x.name, value: x.id }));
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load list items");
    }

    if (!itemList.length) {
      toast.error("No Items");
    } else {
      setItemListItems(itemList);
    }
  };

  const fetchLastDataDate = async () => {
    if (!data.id) {
      return;
    }
    try {
      let dt = await dataProvider.network.get(
        "subscription/last-data-date/" + data.id
      );

      if (dt) {
        setLastDataDate(dt.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load last data date");
    }
  };

  const fetchGroupDetails = async () => {
    if (!data.id) {
      return;
    }
    try {
      let gd = await dataProvider.network.get("group?id=" + data.group.value);
      setGroupDetail(gd);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load group details");
    }
  };

  useEffect(() => {
    fetchLastDataDate();
    fetchGroupDetails();
  }, []);

  const itemList = (
    <Modal onClose={() => setItemListItems([])}>
      <div className="flex">
        <div className="row">
          <h2>Items</h2>
        </div>
      </div>
      <div
        className="flex mtop"
        style={{ minWidth: "30vw", minHeight: "40vh", maxHeight: "50vh" }}
      >
        <div
          className="row sub-preview-lists"
          style={{ paddingRight: "0", marginLeft: "0" }}
        >
          <div className="item-lists" style={{ maxHeight: "100%" }}>
            {itemListItems.map((item, idx) => (
              <div className="row full-row" key={idx}>
                {item.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );

  const now = new Date();

  return (
    <LargeModal onClose={onClose}>
      {itemListItems.length > 0 && itemList}
      <div className="flex flex-v-center">
        <h1>Subscription Preview</h1>
        <div className="right flex">
          {props.showCreateAction &&
            (isLoading ? (
              <div className="loader">
                <div className="lds-hourglass"></div>
              </div>
            ) : (
              <button onClick={createSubscription}>Create</button>
            ))}
          {isEditing ? (
            <>
              <button
                onClick={() => {
                  saveModification();
                }}
              >
                Save
              </button>
              <button
                onClick={() => {
                  setIsEditing(false);
                  setEditDate("");
                  setEditRemarks("");
                }}
              >
                Cancel
              </button>
            </>
          ) : (
            props.allowModify && (
              <button
                onClick={() => {
                  setIsEditing(true);
                }}
              >
                Modify
              </button>
            )
          )}
          {props.allowClone && data.sub_status != '-1' && (
            <button onClick={cloneSubscription}>Clone</button>
          )}
        </div>
      </div>
      <div className="flex sub-preview-wrapper">
        <div className="sub-preview-details">
          {isEditing && (
            <div className="sub-edit">
              <div className="row">
                <h3>Edit</h3>
              </div>
              <div className="row flex flex-v-center">
                <Select
                  value={editType}
                  options={utility.optionFromObject(SUB_MODIFY_TYPES_REVERSE)}
                  placeholder="Edit Type"
                  onChange={e => {
                    setEditType(e);
                    setEditDate("");
                  }}
                />


                <div>
                  <DateInput
                    value={editDate}
                    min={
                      parseInt(editType.value) === SUB_MODIFY_TYPES.SHORT_CLOSE
                        ? lastDataDate
                          ? lastDataDate
                          : now.toISOString().split("T")[0]
                        : parseInt(editType.value) === SUB_MODIFY_TYPES.EXTEND
                        ? data
                          ? data.periodTo
                          : now.toISOString().split("T")[0]
                        : now.toISOString().split("T")[0]
                    }
                    max={
                      groupDetail
                        ? groupDetail.subscription_to
                        : now.toISOString().split("T")[0]
                    }
                    onChange={val => {
                      setEditDate(val);
                    }}
                    placeholder="To date"
                  />
                </div>
              </div>
              <div className="row">
                <textarea
                  value={editRemarks}
                  onChange={e => {
                    setEditRemarks(e.target.value);
                  }}
                  placeholder="Remarks"
                ></textarea>
              </div>
            </div>
          )}
          <div className="full-row">
            <h3>General Details</h3>
          </div>
          <div className="full-row flex" style={{ borderTop: "0" }}>
            <div className="flex-full">Group</div>
            <div className="flex-full">{data.group.label}</div>
          </div>
          <div className="full-row flex">
            <div className="flex-full">Client</div>
            <div className="flex-full">{data.client.label}</div>
          </div>
          <div className="full-row flex">
            <div className="flex-full">Content Type</div>
            <div className="flex-full">
              {CONTENT_TYPES[data.contentType.value]}
            </div>
          </div>
          {data.advertiser && data.advertiser.label.length > 0 && (
            <div className="full-row flex">
              <div className="flex-full">Advertiser</div>
              <div className="flex-full">{data.advertiser.label}</div>
            </div>
          )}
          <div className="full-row flex">
            <div className="flex-full">Period From</div>
            <div className="flex-full">{`${utility.formatDate(
              data.periodFrom
            )}`}</div>
          </div>
          <div className="full-row flex">
            <div className="flex-full">Period To</div>
            <div className="flex-full">{`${utility.formatDate(
              data.periodTo
            )}`}</div>
          </div>
          {data.approvingAuthority && data.approvingAuthority.length > 0 && (
            <div className="full-row flex">
              <div className="flex-full">Approving Authority</div>
              <div className="flex-full">
                {data.approvingAuthority.map(x => x.label).join(", ")}
              </div>
            </div>
          )}
          {data.user.client_type !== CLIENT_BROADCASTER && (
            <div className="full-row flex">
              <div className="flex-full">Category</div>
              <div className="flex-full flex">
                {data.category.length ? (
                  <span>Selected ({data.category.length})</span>
                ) : (
                  <span>All</span>
                )}
                {data.category.length === 0 && (
                  <span
                    className="s-i-e"
                    onClick={() => {
                      loadListItem("category");
                    }}
                  >
                    <EyeIcon />
                  </span>
                )}
              </div>
            </div>
          )}
          {data.user.client_type !== CLIENT_BROADCASTER && (
            <div className="full-row flex">
              <div className="flex-full">Brand</div>
              <div className="flex-full flex">
                {data.brand.length ? (
                  <span>Selected ({data.brand.length})</span>
                ) : (
                  <span>All</span>
                )}
                {data.brand.length === 0 && (
                  <span
                    className="s-i-e"
                    onClick={() => {
                      loadListItem("brand");
                    }}
                  >
                    <EyeIcon />
                  </span>
                )}
              </div>
            </div>
          )}
          {data.user.client_type !== CLIENT_BROADCASTER && (
            <div className="full-row flex">
              <div className="flex-full">Caption</div>
              <div className="flex-full flex">
                {data.caption.length ? (
                  <span>Selected ({data.caption.length})</span>
                ) : (
                  <span>All</span>
                )}
                {data.caption.length === 0 && (
                  <span
                    className="s-i-e"
                    onClick={() => {
                      loadListItem("caption");
                    }}
                  >
                    <EyeIcon />
                  </span>
                )}
              </div>
            </div>
          )}
          {data.user.client_type !== CLIENT_BROADCASTER && (
            <div className="full-row flex">
              <div className="flex-full">Edit</div>
              <div className="flex-full flex">
                {data.edit.length ? (
                  <span>Selected ({data.edit.length})</span>
                ) : (
                  <span>All</span>
                )}
              </div>
            </div>
          )}
          <div className="full-row flex">
            <div className="flex-full">Channels</div>
            <div className="flex-full flex">
              {data.channels.length ? (
                <span>Selected ({data.channels.length})</span>
              ) : (
                <span>All</span>
              )}
              {data.channels.length === 0 && (
                <span
                  className="s-i-e"
                  onClick={() => {
                    loadListItem("channel");
                  }}
                >
                  <EyeIcon />
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="sub-preview-lists">
          <div className="full-row" style={{ marginBottom: "1.5rem" }}>
            <h3>Selected Details</h3>
          </div>
          {data.channels.length > 0 && (
            <div className="full-row">
              <h4>Channels</h4>
              <div className="item-lists">
                {data.channels.map((ch, idx) => (
                  <div className="full-row" key={idx}>
                    {ch.label}
                  </div>
                ))}
              </div>
            </div>
          )}
          {data.category.length > 0 && (
            <div className="full-row">
              <h4>Categories</h4>
              <div className="item-lists">
                {data.category.map((ch, idx) => (
                  <div className="full-row" key={idx}>
                    {ch.label}
                  </div>
                ))}
              </div>
            </div>
          )}
          {data.brand.length > 0 && (
            <div className="full-row">
              <h4>Brands</h4>
              <div className="item-lists">
                {data.brand.map((ch, idx) => (
                  <div className="full-row" key={idx}>
                    {ch.label}
                  </div>
                ))}
              </div>
            </div>
          )}
          {data.caption.length > 0 && (
            <div className="full-row">
              <h4>Captions</h4>
              <div className="item-lists">
                {data.caption.map((ch, idx) => (
                  <div className="full-row" key={idx}>
                    {ch.label}
                  </div>
                ))}
              </div>
            </div>
          )}
          {data.edit.length > 0 && (
            <div className="full-row">
              <h4>Edits</h4>
              <div className="item-lists">
                {data.edit.map((ch, idx) => (
                  <div className="full-row" key={idx}>
                    {ch.label}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </LargeModal>
  );
};

export default SubscriptionPreview;
